<template>
  <div class="view">
    <container>
      <header-group
        heading="Evaluering"
        subheading="Her kan du se hvordan det går med dine deltagere">
      </header-group>
      <h2>Udsend evalueringsskemaer</h2>
      <div class="send-survey">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Navn</th>
              <th>Evaluering</th>
              <th>Udsend evalueringsskemaer</th>
              <th>Resultater</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="attendee in attendees"
            >
              <td>{{attendee.id}}</td>
              <td>{{attendee.name}}</td>
              <td>{{surveyTypeDisplay(attendee)}}</td>
              <td>
                <div v-if="sending === attendee.id" class="sending-message">Sender. Luk ikke for vinduet</div>
                <div v-else>
                  <button class="narrow" @click="sendSurvey('pre', attendee.id)" v-if="allowSendEvaluation(attendee, 'pre')" :disabled="surveyAlreadyAnswered(attendee, 'pre')">Før</button>
                  <button class="narrow" @click="sendSurvey('post', attendee.id)" v-if="allowSendEvaluation(attendee, 'post')" :disabled="surveyAlreadyAnswered(attendee, 'post')">Efter</button>
                  <button class="narrow" @click="sendSurvey('sharp_brains', attendee.id)" v-if="allowSendEvaluation(attendee, 'sharp_brains')" :disabled="surveyAlreadyAnswered(attendee, 'sharp_brains')">Efter</button>
                </div>
              </td>
              <td>
                <span
                  v-if="attendee.survey_type !== ''"
                  class="attendee-results-button"
                  :class="setClasses(attendee.id)"
                  @click="setIndex(attendee.id)"
                >Se resultater</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

<!--
      <h2>Se resultater for</h2>
      <p
        v-for="attendee in attendees"
        class="attendee"
        :class="setClasses(attendee.id)"
        @click="setIndex(attendee.id)">
          {{attendee.name}}
      </p>
      <p
        class="attendee has-survey"
        :class="{'chosen' : this.average}"
        @click="setIndex('AVERAGE')">
          Gennemsnit
      </p>
-->

      <div v-if="preComment">
        <strong>Kommentar før:</strong>
        <p>{{preComment}}</p>
      </div>

      <div v-if="postComment">
        <strong>Kommentar efter:</strong>
        <p>{{postComment}}</p>
      </div>

      <vertical-graph :pre="preAnswers" :post="postAnswers" v-if="preAnswers || postAnswers"></vertical-graph>

    </container>
  </div>
</template>

<script>
import view from '../mixins/view'
import HeaderGroup from 'components/HeaderGroup'
import Graph from 'components/Graph'
import VerticalGraph from 'components/VerticalGraph'
import Bar from 'components/Bar'
import api from 'api'
import { http, SurveyTypes } from 'api/resources'

export default {
  name: 'Survey',
  mixins: [view],
  components: {
    HeaderGroup, Graph, Bar, VerticalGraph
  },
  data () {
    return {
      selectedIndex: 0,
//      average: true,
      sending: false,
    }
  },
  computed: {
    id () {
      return parseInt(this.$route.params.team)
    },
    /*
    isSharpBrains() {
      return this.team !== null && this.team.evaluations.includes('sharp_brains')
    },
    */
    preAnswers () {
      if (this.activeAttendeeIsSharpBrains) {
        return []
      } else {
        //let answers = /*this.average ? this.getSurveyAverage('pre') : */ this.getSurvey('pre', 'answers')
        return this.getSurvey('pre', 'answers') || []
      }
    },
    postAnswers () {
      let key = this.activeAttendeeIsSharpBrains ? 'sharp_brains' : 'post'
      // let answers = this.average ? this.getSurveyAverage(key) : this.getSurvey(key, 'answers')
      return this.getSurvey(key, 'answers') || []
    },
    preComment () {
      return this.getSurvey('pre', 'comment')
    },
    postComment () {
      return this.getSurvey('post', 'comment')
    },
    activeAttendee () {
      return this.attendees && this.attendees.find(attendee => attendee.id === this.selectedIndex)
    },
    activeAttendeeName () {
      return this.activeAttendee && this.activeAttendee.name
    },
    activeAttendeeIsSharpBrains() {
      return this.activeAttendee && this.activeAttendee.survey_type === 'sharp_brains';
    },
    surveysNotDefined () {
      return (!this.surveys || !this.surveys.pre || !this.surveys.post)
    },
    attendees () {
      return this.team && this.team.attendees
    },
  },
  methods: {
    setIndex (index) {
      // if (index === 'AVERAGE') {
      //   /**
      //    * Show average
      //    */
      //   this.average = true
      //   this.selectedIndex = 0
      //   return
      // }
      // this.average = false
      this.selectedIndex = index
    },
    isActive (index) {
      return index === this.selectedIndex
    },
    setClasses (index) {
      return {
        'has-survey': this.hasSurvey(index),
        'chosen': this.isActive(index) /* && !this.average */
      }
    },
    hasSurvey (attendeeIndex) {
      if (!this.surveys) return

      let attendee = this.attendees && this.attendees.find(attendee => attendee.id === attendeeIndex)
      let searchSurveyType = attendee.survey_type === 'sharp_brains' ? 'sharp_brains' : 'pre'
      return this.surveys[searchSurveyType].find(survey => survey.attendee.id === attendeeIndex)
    },
    getSurvey (key, key2) {
      if (this.surveysNotDefined) return

      const survey = this.surveys[key].find(survey => survey.attendee.id === this.selectedIndex)
      if (survey) return survey[key2]
    },
    /*
    getSurveyAverage (key) {
      if (this.surveysNotDefined) return
      return this.surveys[key].average
    },
    */
    sendSurvey (type, attendeeId) {
      if(this.sending !== false) {
        return
      }
      this.sending = attendeeId
      http.post(`me/teams/${this.id}/survey/${type}/attendee/${attendeeId}`).then(response => {
        this.sending = false
        console.log(response)
      })
    },
    hasAnswer (type, index) {
      return this[`${type}Answers`] && this[`${type}Answers`][index]
    },
    allowSendEvaluation(attendee, type) {
      return attendee.evaluations.includes(type);
    },
    surveyAlreadyAnswered(attendee, type) {
      return this.surveys === null || this.surveys[type].find(survey => survey.attendee.id === attendee.id)
    },
    surveyTypeDisplay(attendee) {
      if(this.surveyTypes === null) {
        return '';
      }
      return attendee.survey_type === '' ? '-- ingen --' : this.surveyTypes[attendee.survey_type]
    }
  },
  asyncComputed: {
    surveys () {
      return api.getSurvey(this.id)
    },
    team () {
      return api.getTeams()
      .then(response => response.data)
      .then(teams => teams.find(team => team.id === this.id))
    },
    surveyTypes () {
      return SurveyTypes.get()
      .then(response => response.data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/boilerplate';

h3 {
  opacity: 0.25;

  &.active {
    opacity: 1;
  }
}
.attendee-results-button {
  opacity: .25;
  pointer-events: none;

  &.has-survey {
    opacity: 1;
    cursor: pointer;
    pointer-events: all;
  }
  &.chosen {
    font-weight: bold;
    cursor: default;
  }
}
.graph {
  margin-top: 4rem;
}
.send-survey {
  margin-bottom: 4rem;
}
.legend {
  &.horisontal {
    // display: flex;

    p {
      margin-right: 2rem;
    }
  }
  p {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
  }
  .circle {
    display: block;
    width: 1rem;
    height: 1rem;
    background: currentcolor;
    margin-right: .75rem;
    border-radius: 50%;
    color: #ccc;

    &.post {
      color: $color-orange;
    }
  }
}
.question {
  margin-top: 2rem;
}
.entry {
  display: flex;
  align-items: center;

  p {
    width: 7rem;
    margin: 0;
  }
}

th {
  background-color: #222;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
}

th, td {
  min-width: 120px;
  vertical-align: middle;
  cursor: default;
}

button.narrow {
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
  background-color: #ddd;

  &[disabled] {
    opacity: .25;
    cursor: default;
  }
}

.sending-message {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// Survey.vue?7035e545